// /react/login/LoginCard.jsx

import {
    useMemo,
    useState,
} from "react";

import {
    startContadoriaLogin,
    startContadoriaSignup,
    startGooglePicker,
    startMicrosoftPicker,
    startQuickLogin,
    validateEmail,
} from "./login-auth.js";

import {
    ConfirmDialog,
} from "../components/feedback/ConfirmDialog.jsx";


function Brand() {
    return (
        <div
            className="ld-brand"
            aria-label="CONTADORIA app"
        >
            <img
                src="/icons/logo.svg"
                alt="CONTADORIA logo"
                className="ld-logo"
            />

            <span className="ld-title">
                CONTADORIA

                <span className="ld-title-accent">
                    app
                </span>
            </span>
        </div>
    );
}


function Footer() {
    return (
        <>
            <div className="ld-bottom">
                <div className="ld-footnote">
                    CONTADORIA je chráněna
                    {" "}
                    256-bitovým SSL zabezpečením.
                </div>
            </div>

            <div className="ld-footer-bar">
                <div className="ld-privacy">
                    <a
                        href="https://contadoria.eu/gdpr/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Zásady ochrany soukromí
                    </a>
                </div>

                <div className="ld-socials">
                    <a
                        href="https://contadoria.eu"
                        className="ld-social"
                        aria-label="Web"
                        title="Web"
                    >
                        <img
                            src="/icons/globe.svg"
                            alt=""
                            aria-hidden="true"
                        />
                    </a>

                    <a
                        href="https://www.facebook.com/contadoriacz"
                        className="ld-social"
                        aria-label="Facebook"
                        title="Facebook"
                    >
                        <img
                            src="/icons/facebook-app-symbol.svg"
                            alt=""
                            aria-hidden="true"
                        />
                    </a>

                    <a
                        href="https://www.linkedin.com/company/5338839?trk=prof-exp-company-name"
                        className="ld-social"
                        aria-label="LinkedIn"
                        title="LinkedIn"
                    >
                        <img
                            src="/icons/linkedin.svg"
                            alt=""
                            aria-hidden="true"
                        />
                    </a>
                </div>
            </div>
        </>
    );
}


function getInitials(
    email = ""
) {
    return (
        String(
            email
        )
            .trim()
            .charAt(
                0
            )
            .toUpperCase() ||
        "•"
    );
}


function IdentityMark({
    identitySource,
}) {
    if (
        identitySource ===
        "google"
    ) {
        return (
            <img
                className="ld-provider-icon"
                src="/icons/google.svg"
                alt=""
                aria-hidden="true"
            />
        );
    }


    if (
        identitySource ===
        "microsoft"
    ) {
        return (
            <img
                className="ld-provider-icon"
                src="/icons/microsoft.svg"
                alt=""
                aria-hidden="true"
            />
        );
    }


    return (
        <span
            className="ld-provider-letter"
            aria-hidden="true"
        >
            C
        </span>
    );
}

function getIdentitySource(
    account = {}
) {
    const source =
        String(
            account.provider ??
            account.identitySource ??
            account.identity_source ??
            account.authProvider ??
            account.auth_provider ??
            ""
        )
            .trim()
            .toLowerCase();


    if (
        source ===
        "google"
    ) {
        return "google";
    }


    if (
        source ===
        "microsoft"
    ) {
        return "microsoft";
    }


    return "contadoria";
}

function AccountChip({
    account,
    current = false,
    onForget,
    onError,
}) {
    const email =
        String(
            account?.upn ||
            ""
        )
            .trim()
            .toLowerCase();


    const name =
        String(
            account?.displayName ||
            account?.upn ||
            ""
        ).trim();


    const imgLink =
        String(
            account?.imgLink ||
            account?.img_link ||
            ""
        ).trim();

    const identitySource =
        getIdentitySource(
            account
        );


    async function handleLogin() {
        if (current) {
            window.location.assign(
                "/post-login"
            );

            return;
        }


        const result =
            await startQuickLogin(
                account
            );


        if (
            result?.ok ===
            false
        ) {
            onError?.(
                result.error
            );
        }
    }


    async function handleForget() {
        await onForget?.(
            account
        );
    }


    return (
        <div
            className={
                current
                    ? "ld-account-chip is-current"
                    : "ld-account-chip"
            }

            role="listitem"
        >
            <button
                className="ld-account-main"

                type="button"

                onClick={
                    handleLogin
                }
            >
                {imgLink
                    ? (
                        <span
                            className="ld-account-avatar has-image"

                            aria-hidden="true"
                        >
                            <img
                                className="ld-account-avatar-img"

                                src={
                                    imgLink
                                }

                                alt=""
                            />
                        </span>
                    )
                    : (
                        <span
                            className="ld-account-avatar"

                            aria-hidden="true"
                        >
                            {getInitials(
                                email
                            )}
                        </span>
                    )
                }


                <span className="ld-account-text">
                    <span className="ld-account-name-row">
                        <IdentityMark
                            identitySource={
                                identitySource
                            }
                        />

                        <span className="ld-account-name">
                            {name}
                        </span>
                    </span>


                    <span className="ld-account-mail">
                        {email}
                    </span>
                </span>
            </button>


            <ConfirmDialog
                title={
                    current
                        ? "Odhlásit a zapomenout účet"
                        : "Zapomenout účet"
                }

                description={
                    current
                        ? `Opravdu se chcete odhlásit a zapomenout účet ${email}?`
                        : `Opravdu chcete zapomenout účet ${email}?`
                }

                cancelLabel="Zpět"

                confirmLabel={
                    current
                        ? "Odhlásit"
                        : "Zapomenout"
                }

                variant="danger"

                onConfirm={
                    handleForget
                }

                trigger={
                    <button
                        type="button"

                        className="ld-account-remove"

                        title={
                            current
                                ? "Odhlásit a zapomenout"
                                : "Zapomenout účet"
                        }

                        aria-label={
                            current
                                ? `Odhlásit a zapomenout ${email}`
                                : `Zapomenout ${email}`
                        }
                    >
                        ×
                    </button>
                }
            />
        </div>
    );
}

function getAccountKey(
    account
) {
    const userId =
        String(
            account?.userId ??
            account?.user_id ??
            ''
        ).trim();


    const provider =
        getIdentitySource(
            account
        );


    return (
        `${userId}:${provider}`
    );
}

export function LoginQuickCard({
    accounts,
    controls,
    onForgetAccount,
}) {
    const [
        error,
        setError,
    ] =
        useState(
            ""
        );


    const currentAccounts =
        useMemo(
            () =>
                accounts.filter(
                    account =>
                        account.current ===
                        true
                ),
            [
                accounts,
            ]
        );


    const otherAccounts =
        useMemo(
            () =>
                accounts.filter(
                    account =>
                        account.current !==
                        true
                ),
            [
                accounts,
            ]
        );


    return (
        <div
            className="ld-card"
            aria-label="Rychlé přihlášení do CONTADORIA"
        >
            <Brand />

            <div className="ld-heading">
                Přihlášení
            </div>

            <div className="ld-main">
                <section
                    className="ld-pane ld-quick"
                    aria-live="polite"
                >
                    {currentAccounts.length >
                        0 && (
                        <div className="ld-account-section">
                            <div className="ld-quick-title">
                                Přihlášený účet
                            </div>

                            <div
                                className="ld-account-list"
                                role="list"
                            >
                            {currentAccounts.map(
                                account => (
                                    <AccountChip
                                        key={
                                            getAccountKey(
                                                account
                                            )
                                        }

                                        account={
                                            account
                                        }

                                        current

                                        onForget={
                                            onForgetAccount
                                        }

                                        onError={
                                            setError
                                        }
                                    />
                                )
                            )}
                            </div>
                        </div>
                    )}

                    {otherAccounts.length >
                        0 && (
                        <div className="ld-account-section">
                            <div className="ld-quick-title">
                                Další účty
                            </div>

                            <div
                                className="ld-account-list"
                                role="list"
                            >
                                {otherAccounts.map(
                                    account => (
                                        <AccountChip
                                            key={
                                                getAccountKey(
                                                    account
                                                )
                                            }

                                            account={
                                                account
                                            }

                                            onForget={
                                                onForgetAccount
                                            }

                                            onError={
                                                setError
                                            }
                                        />
                                    )
                                )}
                            </div>
                        </div>
                    )}

                    {error && (
                        <p
                            className="ld-error ld-error--quick"
                            aria-live="polite"
                        >
                            {error}
                        </p>
                    )}
                </section>
            </div>

            <button
                className="ld-mode-toggle"
                type="button"
                onClick={
                    controls.open
                }
            >
                Nové přihlášení
            </button>

            <Footer />
        </div>
    );
}


export function LoginManualCard({
    controls,
}) {
    const [
        email,
        setEmail,
    ] =
        useState(
            ""
        );

    const [
        error,
        setError,
    ] =
        useState(
            ""
        );


    function handleEmailChange(
        event
    ) {
        const value =
            event.target.value;

        setEmail(
            value
        );


        if (!value.trim()) {
            setError(
                ""
            );

            return;
        }


        const result =
            validateEmail(
                value
            );


        setError(
            result.ok
                ? ""
                : result.message
        );
    }


async function handleSubmit(
  event
) {
  event.preventDefault();


  const result =
    validateEmail(
      email
    );


  if (!result.ok) {
    setError(
      result.message
    );

    return;
  }


  setError(
    ""
  );


  await startContadoriaLogin(
    result.email
  );
}

    return (
        <div
            className="ld-card"
            aria-label="Nové přihlášení do CONTADORIA"
        >
            <Brand />

            <div className="ld-heading">
                Přihlášení
            </div>

            <div className="ld-main">
                <form
                    noValidate
                    className="ld-pane ld-form"
                    onSubmit={
                        handleSubmit
                    }
                >
                    <div className="ld-field">
                        <div
                            className={
                                error
                                    ? "ld-input-row is-invalid"
                                    : "ld-input-row"
                            }
                        >
                            <input
                                className="ld-input"
                                type="email"
                                placeholder="E-mail"
                                autoComplete="username"
                                autoCapitalize="none"
                                spellCheck="false"
                                value={
                                    email
                                }
                                aria-invalid={
                                    error
                                        ? "true"
                                        : "false"
                                }
                                onChange={
                                    handleEmailChange
                                }
                            />
                        </div>

                        {error && (
                            <p
                                className="ld-error"
                                aria-live="polite"
                            >
                                {error}
                            </p>
                        )}
                    </div>

                    <button
                        className="ld-primary-btn"
                        type="submit"
                    >
                        Přihlásit se účtem CONTADORIA
                    </button>

                    <button
                        className="ld-create-account-btn"
                        type="button"
                        onClick={
                            startContadoriaSignup
                        }
                    >
                        Nemáte účet? Vytvořit účet
                    </button>

                    <div className="ld-or">
                        nebo
                    </div>

                    <button
                        className="ld-primary-btn ld-google-btn"
                        type="button"
                        onClick={
                            startGooglePicker
                        }
                    >
                        <img
                            className="ld-btn-icon"
                            src="/icons/google.svg"
                            alt=""
                            aria-hidden="true"
                        />

                        Přihlásit se účtem Google
                    </button>


                    <button
                        className="ld-primary-btn ld-microsoft-btn"
                        type="button"
                        onClick={
                            startMicrosoftPicker
                        }
                    >
                        <img
                            className="ld-btn-icon"
                            src="/icons/microsoft.svg"
                            alt=""
                            aria-hidden="true"
                        />

                        Přihlásit se účtem Microsoft
                    </button>
                </form>
            </div>

            <button
                className="ld-mode-toggle"
                type="button"
                onClick={
                    controls.close
                }
            >
                Rychlá přihlášení
            </button>

            <Footer />
        </div>
    );
}